import React from "react";
import * as S from "./styles";
import type { DataProps, FilaProps } from "../../interfaces";

interface Props {
  data: DataProps | null;
}

const FirstOnQueue: React.FC<Props> = (props) => {
  console.log(props?.data?.fila);
  return (
    <S.Container>
      {props?.data?.fila
        .filter((item: FilaProps) => item.posicao !== 1 && item?.ativo === true) // Filtra apenas os itens com posição 1
        .map((item: FilaProps) => (
          <S.Card key={item.idUsuario}>
            <S.CardText>
              <S.CardTextStrong>{item?.nomeCorretor || "--"} </S.CardTextStrong>
              ({item?.nomeEquipeCorretor || "--"})
            </S.CardText>
            <S.CardTextSmall>
              Imobiliaria: {item?.nomeEmpresaVendas || "--"}
            </S.CardTextSmall>
            <S.Position>
              <S.PositionText>{item?.posicao}</S.PositionText>
            </S.Position>
          </S.Card>
        ))}
    </S.Container>
  );
};

export default FirstOnQueue;
